export const secondaryColor = '#ff8a4c';
export const tertiaryColor = '#211e4f';
